import { LegalLayout } from "../components/LegalLayout";
import { PRIVACY_PAGE } from "../data/legalPages";

export default function Privacy() {
  return <LegalLayout page={PRIVACY_PAGE} testId="privacy-page" />;
}
